<template>
  <div class="mini-tab-content">
    <div
      v-if="loading"
      class="interc-loading"
    >
      <b-spinner
        small
        variant="secondary"
      />
      <span>{{ $t('involvedPanel.classification.loading') }}</span>
    </div>

    <template v-else>
      <div
        v-if="classifications.length"
        class="cls-chips"
      >
        <button
          v-for="c in classifications"
          :key="c.id"
          type="button"
          class="cls-chip"
          :class="{ 'cls-chip--on': selected === c.id }"
          :style="{ borderColor: c.hex_color, color: selected === c.id ? chipTextColor(c.hex_color) : c.hex_color, backgroundColor: selected === c.id ? c.hex_color : '#fff' }"
          :disabled="saving"
          @click="choose(c.id)"
        >
          {{ c.color_label }}
        </button>
      </div>

      <small
        v-if="error"
        class="text-danger d-block mt-1"
      >
        {{ error }}
        <a
          href="#"
          class="ml-50"
          @click.prevent="load"
        >{{ $t('involvedPanel.classification.retryLink') }}</a>
      </small>
      <small
        v-else-if="!classifications.length"
        class="text-muted"
      >
        {{ $t('involvedPanel.classification.noneAvailable') }}
      </small>
    </template>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import axios from 'axios'
import involvedPanelMixin from './involvedPanelMixin'
import { getContrastTextColor } from '@/utils/color'

export default {
  name: 'ClassificationPanel',

  components: { BSpinner },

  mixins: [involvedPanelMixin],

  props: {
    involvedClassificationId: { type: [Number, String], default: null },
  },

  data() {
    return {
      classifications: [],
      selected: this.involvedClassificationId ? Number(this.involvedClassificationId) : null,
      loading: false,
      saving: false,
      error: null,
    }
  },

  watch: {
    occurrenceId() {
      this.load()
    },
    involvedClassificationId(value) {
      this.selected = value ? Number(value) : null
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      if (!this.occurrenceId) return
      this.loading = true
      this.error = null
      try {
        const res = await axios.get(`${this.$store.state.api}classifications/for-occurrence/${this.occurrenceId}`)
        this.classifications = res.data.data || []
      } catch (e) {
        this.classifications = []
        this.error = this.$t('involvedPanel.classification.loadError')
      } finally {
        this.loading = false
      }
    },

    choose(id) {
      if (this.saving || this.selected === id) return
      this.change(id)
    },

    chipTextColor(hex) {
      return getContrastTextColor(hex)
    },

    async change(id) {
      const previous = this.selected
      this.selected = id
      this.saving = true
      this.error = null
      try {
        const res = await axios.post(
          `${this.$store.state.api}occurrence_involveds/${this.occurrenceInvolvedId}/classification`,
          { classification_id: id },
        )
        this.$emit('changed', res.data.data.classification)
      } catch (e) {
        this.selected = previous
        this.error = (e.response && typeof e.response.data === 'string')
          ? e.response.data
          : this.$t('involvedPanel.classification.saveError')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.cls-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cls-chip {
  padding: 6px 14px;
  border: 1.5px solid;
  border-radius: 14px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s, color .15s;
}

.cls-chip:disabled { cursor: default; opacity: .65; }
</style>
